import React, { useEffect, useState } from 'react'

import { Table } from 'antd'

import { GiHockey } from 'react-icons/gi'

// Component
import MainHeader from '../components/MainHeader'
import MoveToRoster from '../components/modal/PlayerInterfaceModals/MoveToRoster'

import { getAllIr } from '../redux/actions/rosterAction'
import { getAge } from '../config/helperFunctions'

const InjuredReserve = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    setLoading(true)
    const res = await getAllIr()
    if (res) {
      setData(res)
    }
    setLoading(false)
  }

  const columns = [
    {
      title: ' ',
      dataIndex: 'HostedHeadshotNoBackgroundUrl',
      key: 'HostedHeadshotNoBackgroundUrl',
      render: (_, obj) => {
        return (
          <div className='squad_image_box'>
            {obj?.player?.HostedHeadshotNoBackgroundUrl ? (
              <img src={obj?.player?.HostedHeadshotNoBackgroundUrl} alt={'Player'} />
            ) : (
              <GiHockey size={45} color={'#c4c4c4'} />
            )}
          </div>
        )
      },
    },
    {
      title: 'POSITION',
      dataIndex: 'Position',
      key: 'Position',
      render: (_, obj) => <p>{obj?.player?.Position || '-'}</p>,
    },
    {
      title: 'PLAYER NAME',
      dataIndex: 'Name',
      key: 'Name',
      render: (_, obj) => {
        return <p>{obj?.player?.Name || '-'}</p>
      },
    },
    {
      title: 'AGE',
      dataIndex: 'BirthDate',
      key: 'BirthDate',
      render: (_, obj) => (
        <p className='squad_text1'>{obj?.player?.Age || getAge(obj?.player?.BirthDate) || '-'}</p>
      ),
    },
    {
      title: 'TEAM',
      dataIndex: 'Team',
      key: 'Team',
      render: (_, obj) => <p className='squad_text1'>{obj?.player?.Team || '-'}</p>,
    },
    {
      title: 'OPP',
      dataIndex: 'Opponent',
      key: 'Opponent',
      render: (_, obj) => <p className='squad_text1'>{obj?.player?.Opponent || '-'}</p>,
    },
    {
      title: 'BYE',
      dataIndex: 'ByeWeek',
      key: 'ByeWeek',
      render: (_, obj) => <p className='squad_text1'>{obj?.player?.ByeWeek || '-'}</p>,
    },
    {
      title: 'PLAYER CAP #',
      dataIndex: 'PlayerCap',
      key: 'PlayerCap',
      render: (_, obj) => (
        <p className='squad_text1'>
          {' '}
          {obj?.player?.PlayerCaps ? `$${obj?.player?.PlayerCaps?.toLocaleString()}` : '-'}
        </p>
      ),
    },
    {
      title: 'PF',
      dataIndex: 'pointsPerGame',
      key: 'pointsPerGame',
      render: (_, obj) => (
        <p className='squad_text1'>
          {obj?.player?.pointPerGame > 0 ? obj?.player?.pointPerGame : '-'}
        </p>
      ),
    },
    {
      title: 'PLAYER RANK',
      dataIndex: 'playerRank',
      key: 'playerRank',
      render: (_, obj) => (
        <p className='squad_text1'>{obj?.player?.playerRank > 0 ? obj?.player?.playerRank : '-'}</p>
      ),
    },
    {
      title: ' ',
      dataIndex: 'auction',
      key: 'auction',
      render: (_, obj) => {
        return (
          <MoveToRoster
            activeDate={obj?.activeDate}
            injuredDate={obj?.injuredDate}
            playerId={obj?.PlayerID}
            injuredId={obj?._id}
            getData={getData}
          />
        )
      },
    },
  ]

  return (
    <div className='practice_squad_container team_trade_main'>
      <MainHeader headingAndDate={false} />

      <div className='header' style={{ marginBlock: '20px' }}>
        <h2>INJURED RESERVE</h2>
      </div>
      <div className='new_table_container'>
        <Table
          loading={loading}
          dataSource={data?.injuredReserved}
          columns={columns}
          bordered={false}
          pagination={false}
          scroll={{ x: 1100 }}
          rowKey='_id'
        />
      </div>

      <div className='header' style={{ marginBlock: '20px' }}>
        <h2>LONG TERM INJURED RESERVE</h2>
      </div>
      <div className='new_table_container'>
        <Table
          loading={loading}
          dataSource={data?.LtInjuredReserved}
          columns={columns}
          bordered={false}
          pagination={false}
          scroll={{ x: 1100 }}
          rowKey='_id'
        />
      </div>
    </div>
  )
}

export default InjuredReserve
